import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Col, Form, Input, Row, InputNumber, Tabs, message, DatePicker, Select } from 'antd';
import { usePageTitle } from '../../../context/pageTitleContext';
import { dateFormat, menuLinks, selectOptionsTypes } from '../../../utils/constants';
import { SaveOutlined, RollbackOutlined } from '@ant-design/icons';
import Loader from '../../../components/common/Loader';
import { useLoader } from '../../../context/loaderContext';
import { useNavigate, useParams } from 'react-router';
import CustomerOrderItems from './customerOrderItems';
import UpdateOrderItem from './updateOrderItem';
import dayjs from 'dayjs';
import AddOrderItem from './addOrderItem';
import CustomerOrdersServices from '../../../services/customerOrdersServices';
import { Can, permissions } from '../../../utils/permissionUtils';
import { useUserAuth } from '../../../context/UserContext';
import DynamicSelect from '../../../components/common/dynamicSelect';
import { useSelector } from 'react-redux';
import { handleDateConvertForApis } from '../../../utils/functions';


const CustomerOrderDetails = () => {
    const { t } = useTranslation();
    const { loading, setLoading, setHasError } = useLoader();
    const salesOrganization = useSelector((state: any) => state.utils.salesOrganization);

    const [form] = Form.useForm();
    const urlParams = useParams();
    const { user } = useUserAuth();

    const { setPageTitle } = usePageTitle();
    const [orderData, setOrderData] = useState(null);
    const [orderRowsData, setOrderRowsData] = useState([]);
    const [openUpdateDrawer, setOpenUpdateDrawer] = useState(false);
    const [openInsertDrawer, setOpenInsertDrawer] = useState(false);
    const [selectedOrderItem, setSelectedOrderItem] = useState(null);
    const [activeTab, setActiveTab] = useState("1");

    const [shipToObjectData, setShipToObjectData] = useState(null);
    const [shipToObjectDataLoading, setShipToObjectDataLoading] = useState(false);
    const [soldToObjectData, setSoldToObjectData] = useState(null);
    const [soldToObjectDataLoading, setSoldToObjectDataLoading] = useState(false);


    const navigate = useNavigate();

    useEffect(() => {
        setPageTitle(t('page.orderDetails'));
        getOrderDetails();
    }, []);

    const onCloseDrawer = (drawerName: string) => {
        if (drawerName === "create") setOpenInsertDrawer(false);
        if (drawerName === "update") setOpenUpdateDrawer(false);
    };

    const showDrawer = (drawerName: string, record: any) => {
        if (drawerName === "create") setOpenInsertDrawer(true);
        if (drawerName === "update") setOpenUpdateDrawer(true); setSelectedOrderItem(record);
    }

    const getOrderDetails = async () => {
        setLoading(true);
        try {
            const respData = await CustomerOrdersServices.getOrderDetails(urlParams.id as string, user.id as string);
            if (respData.success) {
                let result = respData.responseObject.value.orderDetails[0];
                setOrderData(result.orderHeader);
                setOrderRowsData(result.orderItem);
                setLoading(false);
            } else {
                message.error(t('messages.errorAccured'));
                setHasError(true);
            }
        } catch (error) {
            message.error(t('messages.errorAccured'));
            setHasError(true);
        }
    }

    const onOrderSave = async () => {

        try {
            const values = await form.validateFields();
            values.orderDate = handleDateConvertForApis(values.orderDate);
            values.requestedDeliveryDate = handleDateConvertForApis(values.requestedDeliveryDate);

            console.log("order update values", values);


        } catch (errorInfo) {
            console.log('Validation Failed:', errorInfo);
            message.error(t('messages.formValidationError'));
        }


    }

    const onOredItemSave = async (values: any) => {
        console.log("ff", values)
    }

    const onOredItemInsert = async (values: any) => {
        console.log("ff", values)
    }

    const onShipToPartySelect = async (type: any, shipToSelected: any) => {

        // setShipToObjectDataLoading(true);
        // try {
        //     const respData = await CustomerOrdersServices.getShipTo(shipToSelected.value);

        //     if (respData.success) {

        //     setShipToObjectData(respData);

        //     } else {
        //          message.error(t('messages.errorAccured'));
        //     }
        // } catch (error) {
        //      message.error(t('messages.errorAccured'));
        // } finally {
        //     setShipToObjectDataLoading(false);
        // }

    }

    const onSoldToPartySelect = async (type: any, soldToSelected: any) => {

        // setSoldToObjectDataLoading(true);
        // try {
        //     const respData = await CustomerOrdersServices.getSoldTo(soldToSelected.value);

        //     if (respData.success) {

        //         setSoldToObjectData(respData);

        //     } else {
        //          message.error(t('messages.errorAccured'));
        //     }
        // } catch (error) {
        //      message.error(t('messages.errorAccured'));
        // } finally {
        //     setSoldToObjectDataLoading(false);
        // }

    }

    const onSelectOptionChange = (type: any, selectedOption: any) => {

    }

    const OrderHeader = ({ orderHeaderData }: { orderHeaderData: any }) => {
        return (
            <>
                <Form
                    layout={"vertical"}
                    form={form}
                    size='small'
                    className='orderData orderFields'
                    disabled
                >
                    <Row gutter={[16, 16]}>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} >
                            <Card title="Order Details" size='small'>
                                <Row gutter={[16, 24]}>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.orderNumber')}
                                            name="orderNumber"
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                            initialValue={orderHeaderData.orderNumber}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.orderType')}
                                            name="orderType"
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                            initialValue={orderHeaderData.orderType}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.orderType} value={undefined} onChange={undefined} onSelectChange={onSelectOptionChange} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.orderDate')}
                                            name="orderDate"
                                            initialValue={orderHeaderData.orderDate && dayjs(orderHeaderData?.orderDate)}
                                        >
                                            <DatePicker style={{ width: "100%" }} format={dateFormat} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.totalAmount')}
                                            name="totalAmount"
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                            initialValue={orderHeaderData.totalAmount}
                                        >
                                            <InputNumber style={{ width: "100%" }} min={0} precision={2} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.billToParty')}
                                            name="billToParty"
                                            initialValue={orderHeaderData.billToParty}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.billToParty} value={undefined} onChange={undefined} onSelectChange={onSelectOptionChange} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.shipTo')}
                                            name="shipToParty"
                                            initialValue={orderHeaderData.shipToParty}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.shipTo} value={undefined} onChange={undefined} onSelectChange={onShipToPartySelect} />
                                        </Form.Item>
                                    </Col>


                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.soldTo')}
                                            name="soldToParty"
                                            initialValue={orderHeaderData.soldToParty}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.soldTo} value={undefined} onChange={undefined} onSelectChange={onSoldToPartySelect} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.billingBlock')}
                                            name="billingBlock"
                                            initialValue={orderHeaderData.billingBlock}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.billingBlock} value={undefined} onChange={undefined} onSelectChange={onSelectOptionChange} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.deliveryBlock')}
                                            name="deliveryBlock"
                                            initialValue={orderHeaderData.deliveryBlock}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.deliveryBlock} value={undefined} onChange={undefined} onSelectChange={onSelectOptionChange} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.division')}
                                            name="division"
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                            initialValue={orderHeaderData.division}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.division} value={undefined} onChange={undefined} onSelectChange={onSelectOptionChange} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.orderReason')}
                                            name="orderReason"
                                            initialValue={orderHeaderData.orderReason}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.orderReason} value={undefined} onChange={undefined} onSelectChange={onSelectOptionChange} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.payer')}
                                            name="payer"
                                            initialValue={orderHeaderData.payer}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.paymentTerms')}
                                            name="paymentTerms"
                                            initialValue={orderHeaderData.paymentTerms}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.paymentTerms} value={undefined} onChange={undefined} onSelectChange={onSelectOptionChange} />
                                        </Form.Item>
                                    </Col>


                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.poNumber')}
                                            name="poNumber"
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                            initialValue={orderHeaderData.poNumber}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>


                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.quotationNumber')}
                                            name="quotationNumber"
                                            initialValue={orderHeaderData.quotationNumber}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>


                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.reqDeliveryDate')}
                                            name="requestedDeliveryDate"
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                            initialValue={dayjs(orderHeaderData?.requestedDeliveryDate)}

                                        >
                                            <DatePicker style={{ width: "100%" }} format={dateFormat} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >

                                        <Form.Item
                                            label={t('order.salesOrganization')}
                                            name="salesOrganization"
                                            initialValue={orderHeaderData.salesOrganizationID}
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                        >
                                            <DynamicSelect location="update" type={selectOptionsTypes.salesOrganization} value={undefined} onChange={undefined} onSelectChange={onSelectOptionChange} />
                                        </Form.Item>

                                        {/* <Form.Item
                                            label={t('order.salesOrganization')}
                                            name="salesOrganization"
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                            initialValue={orderHeaderData.salesOrganizationID}
                                        >
                                            <Select
                                                showSearch
                                                optionFilterProp="label"
                                                placeholder={t('general.select')}
                                                options={salesOrganization.map((item) => ({ value: item.id, label: item.code }))}
                                                onChange={(value, option) => onSelectOptionChange('salesOrganization', option)}
                                            />
                                        </Form.Item> */}
                                    </Col>

                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                        <Form.Item
                                            label={t('order.distributionChannel')}
                                            name="distributionChannel"
                                            rules={[{ required: true, message: t('messages.requiredField') }]}
                                            initialValue={orderHeaderData.distributionChannel}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </Card>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                            <Row gutter={[16, 16]}>

                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
                                    <Card title={t('order.customerSoldTo')} size='small'>
                                        <Row gutter={[16, 16]}>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.name')}
                                                    name="customerName"
                                                    initialValue={orderHeaderData.customerName}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.email')}
                                                    name="customerEmail"
                                                    initialValue={orderHeaderData.customerEmail}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.mobilePhone')}
                                                    name="customerMobilePhone"
                                                    initialValue={orderHeaderData.customerMobilePhone}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.telephone')}
                                                    name="customerTelephone"
                                                    initialValue={orderHeaderData.customerTelephone}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.city')}
                                                    name="customerCity"
                                                    initialValue={orderHeaderData.customerCity}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.region')}
                                                    name="customerRegion"
                                                    initialValue={orderHeaderData.customerRegion}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.postalCode')}
                                                    name="customerPostalCode"
                                                    initialValue={orderHeaderData.customerPostalCode}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.streetAddress')}
                                                    name="customerStreetAddress"
                                                    initialValue={orderHeaderData.customerStreetAddress}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 1"}
                                                    name="customerTaxNumber1"
                                                    initialValue={orderHeaderData.customerTaxNumber1}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 2"}
                                                    name="customerTaxNumber2"
                                                    initialValue={orderHeaderData.customerTaxNumber2}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 4"}
                                                    name="customerTaxNumber4"
                                                    initialValue={orderHeaderData.customerTaxNumber4}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>

                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
                                    <Card title={t('order.shipTo')} size='small'>
                                        <Row gutter={[16, 16]}>
                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.name')}
                                                    name="contactFullName"
                                                    initialValue={orderHeaderData.contactFullName}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.email')}
                                                    name="contactEmail"
                                                    initialValue={orderHeaderData.contactEmail}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.mobile')}
                                                    name="contactMobilePhone"
                                                    initialValue={orderHeaderData.contactMobilePhone}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.telephone')}
                                                    name="contactTelephone"
                                                    initialValue={orderHeaderData.contactTelephone}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.city')}
                                                    name="contactCity"
                                                    initialValue={orderHeaderData.contactCity}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.region')}
                                                    name="contactRegion"
                                                    initialValue={orderHeaderData.contactRegion}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.postalCode')}
                                                    name="contactPostalCode"
                                                    initialValue={orderHeaderData.contactPostalCode}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.streetAddress')}
                                                    name="contactStreetAddress"
                                                    initialValue={orderHeaderData.contactStreetAddress}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 1"}
                                                    name="contactTaxNumber1"
                                                    initialValue={orderHeaderData.contactTaxNumber1}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 2"}
                                                    name="contactTaxNumber2"
                                                    initialValue={orderHeaderData.contactTaxNumber2}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 4"}
                                                    name="contactTaxNumber4"
                                                    initialValue={orderHeaderData.contactTaxNumber4}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </>
        )
    }


    const items = [
        {
            key: '1',
            label: t('order.order'),
            children: <OrderHeader orderHeaderData={orderData} />,
        },
        {
            key: '2',
            label: t('order.orderItems'),
            children: <CustomerOrderItems rowsData={orderRowsData} onEdit={showDrawer} onCreate={() => showDrawer("create", undefined)} />,
        }
    ];

    if (loading) { return (<Loader />) }

    return (

        <div className="customerOrderDetails">

            {selectedOrderItem && (
                <UpdateOrderItem onOrderItemSave={onOredItemSave} open={openUpdateDrawer} onClose={() => onCloseDrawer("update")} recordData={selectedOrderItem} />
            )}

            {openInsertDrawer && (
                <AddOrderItem onOrderItemInsert={onOredItemInsert} open={openInsertDrawer} onClose={() => onCloseDrawer("create")} recordData={undefined} />
            )}

            {orderData && (
                <Card>
                    <Tabs
                        defaultActiveKey={activeTab}
                        onChange={(activeKey) => { setActiveTab(activeKey) }}
                        items={items}
                        tabBarExtraContent={
                            <>
                                <Button size='small' onClick={() => navigate(menuLinks.customerOrders)} icon={<RollbackOutlined />} type="default">{t('order.returnToOrders')}</Button>
                                {/* {activeTab === "1" && (
                                    <Can permission={permissions.UPDATE_ORDER}>
                                        <Button onClick={onOrderSave} icon={<SaveOutlined />} className='ml10' size='small' type="primary" htmlType='submit'>{t('general.save')}</Button>
                                    </Can>
                                )} */}
                            </>
                        } />
                </Card>
            )}

        </div>

    );
}
export default CustomerOrderDetails;